/* 产品规格选择 */
<template>
  <div>
    <div class="proload-space">
      <p class="title">重新选择规格</p>
      <Row
        class="proload-space-item"
        v-for="(item, index) in choicedSpec"
        v-if="item.visible"
        :key="index"
        :gutter="30"
        type="flex"
        justify="center"
        align="middle"
      >
        <Col span="6">
          <z-panelimg
            :del="false"
            width="70"
            height="70"
            :src="item.specFile ? ossUrl + item.specFile.key : ''"
          ></z-panelimg>
        </Col>

        <Col span="15" class="text">
          <p class="item-title">参数</p>
          <div class="main">
            <span class="title">
              <Tooltip
                max-width="200"
                :content="item.color"
                theme="light"
                placement="bottom"
              >颜色：{{item.color || '暂无'}}</Tooltip>
            </span>
            <span class="title">
              <Tooltip
                max-width="200"
                :content="item.size"
                theme="light"
                placement="bottom"
              >尺寸：{{item.size || '暂无'}}</Tooltip>
            </span>

            <span class="title title-material">
              <Tooltip
                max-width="200"
                :content="item.material"
                theme="light"
                placement="top"
              >材质：{{item.material || '暂无'}}</Tooltip>
            </span>
          </div>
        </Col>
        <Col span="2" class="text">
          <Radio
            :disabled="showCustom"
            @on-change="chioceSpec(item, index)"
            size="large"
            v-model="item.choiced"
          ></Radio>
        </Col>
      </Row>
    </div>

    <!-- style="position: fixed;
      top: 458px;
      padding: 15px 10px;
      width: 100%;
      background: #fff;
    text-align: right;"-->

    <!-- <div class="bottom-btn" style="width: 100%;margin-top: 50px;text-align: center;">
      <Button :loading="loading" class="red-btn" size="large" type="primary" @click="submit">保存</Button>
    </div> -->
  </div>
</template>
<script>
import { findComponentDownward } from "../../../utils/assist.js";
import ZPanelimg from "../../panelimg/panelimg";
export default {
  name: "ZSpeclog",
  data() {
    return {
      diaologDom: null,
      single: false
    };
  },
  components: { ZPanelimg },
  props: {
    showCustom: {
      type: Boolean,
      default: true
    },
    choicedSpec: {
      type: Array,
      default: function() {
        return [];
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    ossUrl: {
      type: String,
      default: ""
    }
  },
  mounted() {
    const Dialog = findComponentDownward(this, "ZDialog");
    if (Dialog) {
      this.diaologDom = Dialog;
    }
  },
  watch: {
    display: function() {
      if (this.display) {
        this.diaologDom.op();
      } else {
        this.diaologDom.close();
      }
    }
  },
  methods: {
    closeDialog() {
      this.$emit("close");
    },
    submit() {
      const newObj =
        this.choicedSpec && this.choicedSpec.filter(item => item.choiced)[0];
      if (!newObj) {
        this.$Message.warning("至少选择一个规格！");
        return false;
      }
      if (this.showCustom) {
        this.$emit("submitHandleSpace", null);
      } else {
        this.$emit("submitHandleSpace", newObj);
      }
    },
    chioceSpec(item, index) {
      this.choicedSpec.forEach(item => {
        this.$set(item, "choiced", false);
      });
      this.$set(this.choicedSpec[index], "choiced", true);
    }
  }
};
</script>

<style lang="scss">
.proload-space {
  margin-left: 10px;
  margin-top: 30px;
  > .title {
    color: #373737;
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 20px;
    text-align: left;
    margin-left: -10px;
  }
  .proload-space-item {
    padding: 15px;
    background: rgba(250, 250, 250, 1);
    margin-bottom: 10px;
    padding-left: 0px;
  }
  .text {
    .item-title {
      font-size: 16px;
      font-weight: 400;
      margin-bottom: 10px;
    }
    .main {
      .ivu-tooltip {
        width: 100%;
      }
      .ivu-tooltip .ivu-tooltip-rel {
        font-size: 12px;
        font-weight: 400;
        color: rgba(49, 49, 49, 1);
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
      .title {
        display: inline-block;
        vertical-align: middle;
        font-size: 12px;
        font-weight: 400;
        color: rgba(49, 49, 49, 1);
        margin-bottom: 0px;
        margin-right: 10px;
        width: 45%;
        text-align: left;
        padding-right: 10px;
      }
      .title-material {
        width: 90%;
      }
    }
  }
  .bottom-btn {
    width: 100%;
    margin-top: 30px;
    text-align: center;
    //   position: fixed;
    //   top: 463px;
    //   padding: 15px 10px;
    //   width: 100%;
    //   background: #fff;
    //   text-align: right;
  }
}
</style>
